import { get } from "lodash";
import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import {
  normalizeTextField,
  stripAllSpaces,
} from "utils/helpers/validations";
import { validateBIC, validateIBAN } from "utils/helpers/values";
import * as yup from "yup";

const validation = (messages) => {
  const string = yup.string().typeError(messages.REQUIRED).nullable();
  const textField = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.NOT_STRING)
    .nullable();
  const noSpaceString = yup.string().transform(stripAllSpaces);
  const nameValidation = textField
    .notRequired()
    .test(
      "is-valid-name",
      messages.INVALID_NAME,
      (value) => !value || REGEX_EXPS.name.test(value),
    );
  return yup.object().shape({
    contactTelecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: yup
          .string()
          .nullable()
          .matches(REGEX_EXPS.zipCode, messages.INVALID_ZIP_CODE)
          .required(messages.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.CITY]: yup.object().shape({
        value: yup.string().nullable().required(messages.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.ADDRESS]: yup.object().shape({
        value: textField.required(messages.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.EMAIL]: yup.object().shape({
        value: yup
          .string()
          .nullable()
          .email(messages.EMAIL)
          .required(messages.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.PHONE]: yup.object().shape({
        value: noSpaceString
          .typeError(messages.REQUIRED)
          .required(messages.REQUIRED)
          .test("isValid", messages.INVALID_VALUE, async function (value) {
            return new RegExp(REGEX_EXPS.phone).test(value);
          }),
      }),
    }),
    payment: yup.object().shape({
      payer: yup.object().shape({
        BIC: noSpaceString
          .typeError(messages.NOT_STRING)
          .nullable()
          .test(
            "validateBIC",
            messages.INVALID_BIC || messages.INVALID_IBAN,
            function (value) {
              if (!value) return true;
              const result = validateBIC(value);
              return result.valid;
            },
          ),
        IBAN: noSpaceString
          .typeError(messages.REQUIRED)
          .nullable()
          .notRequired()
          .test("validateIBAN", messages.INVALID_IBAN, function (value, ctx) {
            if (!value) return true;
            const result = validateIBAN(value);
            if (!result.valid)
              return ctx.createError({
                message: get(messages, result.reason, messages.INVALID_VALUE),
              });

            return true;
          }),
        owner: yup.object().shape({
          isAdherent: yup.boolean().typeError(messages.NOT_BOOLEAN),
          firstName: nameValidation,
          lastName: nameValidation,
        }),
      }),
      receiver: yup.object().shape({
        BIC: noSpaceString
          .typeError(messages.NOT_STRING)
          .nullable()
          .test(
            "validateBIC",
            messages.INVALID_BIC || messages.INVALID_IBAN,
            function (value) {
              if (!value) return true;
              const result = validateBIC(value);
              return result.valid;
            },
          ),
        IBAN: noSpaceString
          .typeError(messages.REQUIRED)
          .nullable()
          .notRequired()
          .test("validateIBAN", messages.INVALID_IBAN, function (value, ctx) {
            if (!value) return true;
            const result = validateIBAN(value);
            if (!result.valid)
              return ctx.createError({
                message: get(messages, result.reason, messages.INVALID_VALUE),
              });

            return true;
          }),
        owner: yup.object().shape({
          firstName: nameValidation,
          lastName: nameValidation,
        }),
      }),
    }),
    consent: yup.object().shape({
      optinMarketing: yup.boolean().oneOf([true], messages.REQUIRED),
      optinPartners: yup.boolean().oneOf([true], messages.REQUIRED),
      acceptCGV: yup.boolean().oneOf([true], messages.REQUIRED),
      acceptSepa: yup.boolean().oneOf([true], messages.REQUIRED),
    }),
  });
};

export default validation;
